import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-temperature-slider',
  templateUrl: './temperature-slider.component.html',
  styleUrls: ['./temperature-slider.component.scss']
})
export class TemperatureSliderComponent implements OnInit, OnDestroy {
  @Input() visible: boolean = false;

  minTemp: number = 40;
  maxTemp: number = 45;
  currentTemp: number = 40;

  private destroy$ = new Subject<void>();
  private currentParams: any = {};

  get midTemp(): number { return (this.minTemp + this.maxTemp) / 2; }

  constructor(private gisUtils: UtilsService) { }

  ngOnInit() {
    this.gisUtils.getSelectedParams().pipe(takeUntil(this.destroy$)).subscribe((params: any) => {
      if (params && Object.keys(params).length) {
        this.currentParams = params;
        if (params['temperature'] != null) {
          this.currentTemp = +params['temperature'];
        }
      }
    });
  }

  onTempChange(value: number) {
    this.currentTemp = +value;
    const updatedParams = { ...this.currentParams, temperature: this.currentTemp };
    this.gisUtils.setSelectedParams(updatedParams);
  }

  get fillPercent(): number {
    return ((this.currentTemp - this.minTemp) / (this.maxTemp - this.minTemp)) * 100;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
